import { Link } from 'react-router-dom'
import { Icon } from '../../Elements'

const CardMain = ({
  children,
  className,
  classIcon,
  path,
}: CardMainInterface) => {
  return (
    <>
      <Link
        to={path}
        className={`${
          className ?? ''
        } flex justify-center items-center flex-col shadow-inner`}
      >
        <Icon icon={classIcon ?? ''} className='text-5xl'></Icon>
        <span className='text-xs'>{children}</span>
      </Link>
    </>
  )
}

export default CardMain
